<template>
 <div  class="right-box" :style="right_open_style"


 >
	 <el-row  class="right-dialog" v-show="visiable">

	 		<el-row class="tool">

	 			  <slot  name="tool">

            <!--标题-->
            <slot name="title">
                <svg class="icon" aria-hidden="true"
                     v-if="icon!=''"
                     style="width: 1.2em;height: 1.2em;position:relative;top:1px;left:3px;"
                >
                  <use :xlink:href="icon"></use>
                </svg>
              <span  class="el-dialog__title header-title">{{title}}</span>

            </slot>

            <!--关闭按钮-->
             <button type="button" aria-label="Close" class="el-dialog__headerbtn box-header-btn" @click="handle_close">
                  <i class="el-dialog__close el-icon el-icon-close"></i>
                </button>



            <!--<omnis-button href="#the_third_iconguanbi2" button_name="关闭"-->
                      <!--@handle_click="handle_close"></omnis-button>-->
            	 </slot> 
	 		</el-row>
          
            <el-row class="dialog-body">
            	<slot  name="body">
            	</slot>
            </el-row>


     </el-row>
</div>
	
</template>
<script type="text/javascript">
  import OmnisButton from "@/components/common_page/omnis_button"

	
	export default{
    components:{

      OmnisButton,
    },
		props:{
      icon:{
        type:String,
      },
			right_open_width:{
				type:String,
				default:"70%"
			},
			visiable:{
				type:Boolean,
				default:false,
			},

      beforeClose: Function,

      title:{
			  type:String,
				default:""
      },
		},
		data(){
			return {
				right_open_style:{},
			}
		},
		watch:{
			visiable(value){
				if(value){
					this.right_open_style ={"width":this.right_open_width}
				}else{
					this.right_open_style = {}
				}
				
			}
		},
		computed:{
			// right_open_class(){

			// 	if(this.visiable){
			// 		return {"width":this.right_open_width}
			// 	}
			// 	return {}
			// }
		},

    mounted(){
      // var _this = this
      // document.onclick = function (e) {
      //     var target_el = _this.$el
      //   debugger
      //     if(target_el){
      //       if(!target_el.contains(e.target) && _this.visiable){            //如果点击到了组件以外的区域
      //         _this.handle_close()
      //       }
      //     }
      // };
    },

    methods:{

      // 点击关闭按钮
      handle_close(){
        if (typeof this.beforeClose === 'function') {
          this.beforeClose(this.close);
        } else {
          this.close();
        }
      },

      // 关闭
      close(){
        this.$emit('update:visiable', false);
      },
    },
	}
</script>
<style type="less" scoped>

.tool{
	height: 30px;
	padding-top: 2px;
	background: #f0f0f0;
	display: flex;
}
.dialog-body{
		height:100%;
		width:100%;
		position: absolute;
		top: 30px;
		padding-bottom: 30px
	}
.right-dialog {
	height: 100%;
  overflow: hidden;
	

}
.right-box{
    position: absolute;
    z-index: 2000;
    top: 0;
    right: 0;
    height: 100%;
    width: 0;
    opacity: 1;
    box-shadow: 0 8px 10px -5px rgba(0,0,0,.2), 0 16px 24px 2px rgba(0,0,0,.14), 0 6px 30px 5px rgba(0,0,0,.12);
    background-color: #FcFcFc;
    transition: width 0.8s;
 }

  .box-header-btn{
    position:absolute;
    top:5px;
    right:20px;
    padding:0;
    background:0 0;
    border:none;
    outline:0;
    cursor:pointer;
    font-size:16px
  }

  .header-title{
    padding: 0 10px;
    font-size: 14px;
  }


</style>



// WEBPACK FOOTER //
// index.vue?8639cf98